<template>
  <div class="starter-edition-content">
    <div class="starter-edition-result" v-if="showResult">
      <img :src="imgUrl" class="img-result" style="width: 100%; height: auto;">
    </div>
    <div class="starter-edition-entry" v-if="showEntry">
      <div class="starter-register-content" @click="gotoRegister">
        <div class="container">
          <i class="iconfont icon-register" />
          <div class="register-title" >还没有亿方云账号？</div>
          <div class="register-action">注册领取优惠</div>
        </div>
      </div>
      <div class="starter-phone-content" @click="verifyAccount">
        <div class="container">
          <i class="iconfont icon-phone" />
          <div class="account-title">已有亿方云管理员账号</div>
          <div class="phone-action">输入手机号领取优惠</div>
        </div>
      </div>
    </div>
    <phone-verify v-if="showVerify"  :callback="submitAccountInfo" />
  </div>
</template>

<script>
import { i18n } from '@/utils/i18n'
import Quan from '@/assets/start-edition-sales@3x.png'
import PhoneVerify from './PhoneVerify'
import ajax from '../../utils/ajax'
import { alert, toast } from '../../utils/common'

export default {
  name: 'StarterEditionSales',
  i18n,
  components: {
    PhoneVerify
  },
  props: {
    action: ''
  },
  created () {
    this.showEntry = !this.showResult
  },
  data () {
    return {
      imgUrl: Quan,
      showEntry: false,
      showVerify: false
    }
  },
  computed: {
    showResult () {
      return this.action === 'finish'
    }
  },
  watch: {},
  methods: {
    gotoRegister () {
      const registerBaseUrl = process.env.BUILD_ENV === 'dist' ? 'https://account.fangcloud.com' : 'https://account.fangcloud.net'
      const registerUrl = `${registerBaseUrl}/register?plan_id=27&origin=360wechat`
      const backUrl = `${window.location.origin}/h5/promotion?type=110`
      window.location.href = registerUrl + '&redirect=' + encodeURIComponent(backUrl)
    },
    verifyAccount () {
      this.showEntry = false
      this.showVerify = true
    },
    submitAccountInfo (data) {
      ajax({
        urlPrefix: '/',
        url: 'coupon/create',
        data: {
          country: `(${data.region})`,
          phone: data.phone,
          code: data.smscode,
          group_id: 1
        },
        loading: '正在发送',
        accept_errors: ['permission_denied']
      }).then(result => {
        console.log(result)
        if (result.success) {
          this.showVerify = false
          this.action = 'finish'
          toast.success('已成功领取')
        } else if (result.errors) {
          if (result.errors.permission_denied) {
            alert('企业管理员才可领取优惠券').then(() => {})
          }
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="postcss">
@import "variables";
.starter-edition-content{
  display: flex;
  height: 100%;
  width: 100%;
  & .starter-edition-result{
    overflow-y: scroll;
    width: 100%;
    height: 100%;
  }
  & .starter-edition-entry{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    & .starter-register-content{
      flex: 1 1 auto;
      width: 100%;
      background: #017ffd;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      & .container {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        & .register-title {
          font-family: PingFang SC;
          font-size: 24px;
          color: #ffffff;
          font-weight: bold;
          text-align: center;
          line-height: 32px;
          padding-top: 40px;
        }
        & .register-action {
          width:250px;
          height: 48px;
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 20px;
          color: #017ffd;
          text-align: center;
          line-height: 48px;
          margin-top: 28px;
          background: #fff;
          border-radius: 24px;
        }
        & .icon-register {
          color: #fff;
          font-size: 60px;
        }
      }
    }
    & .starter-phone-content{
      flex: 1 1 auto;
      width: 100%;
      background: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      & .container {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        & .account-title {
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 24px;
          color: #333333;
          text-align: center;
          line-height: 32px;
          padding-top: 40px;
        }
        & .phone-action {
          width:250px;
          height: 48px;
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 20px;
          color: #017ffd;
          text-align: center;
          line-height: 48px;
          margin-top: 28px;
          background: #fff;
          border-radius: 24px;
          border: 1px solid #017ffd;
        }
        & .icon-phone {
          color: #017ffd;
          font-size: 60px;
        }
      }
    }
  }
}
</style>
